import '@mui/x-data-grid-pro';
import type { Player } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { createEditColumn, createIsActiveColumn, createSportIconColumn } from '../../helpers/columns';
import { defaultColumnsPlayers } from '../../helpers/table';
import useMutateData from '../../hooks/useMutateData';
import { usePagination } from '../../hooks/usePagination';
import useSort from '../../hooks/useSort';
import { createColumn } from '../../utils';
import TableTemplate from '../templates/TableTemplate';

const PlayersPage = () => {
  const { data: playersData, updateQueryParams, isFetching, isLoading, changeQuery } = usePagination<Player>('players');
  const { deleteData, updateData } = useMutateData('players', [QUERY_KEYS.players]);
  const { handleSort } = useSort(changeQuery);

  const columns = [
    createColumn('id', 'ID', {
      sortable: false,
    }),
    createColumn('firstName', 'First Name'),
    createColumn('lastName', 'Last Name'),
    createColumn('displayName', 'Display Name'),
    createColumn('sportName', 'Sport', {
      valueGetter: (value, row, column, apiRef) => row.sport.name,
    }),
    createSportIconColumn<Player>(),
    createColumn('competitionName', 'Competitions', {
      minWidth: 150,
      valueGetter: (value, row, column, apiRef) => {
        return row.competitions.map((competition: Player['competitions'][number]) => competition.name).join(', ');
      },
    }),
    createColumn('tournamentName', 'Tournaments', {
      minWidth: 150,
      valueGetter: (value, row, column, apiRef) =>
        row.tournaments.map((tournament: Player['tournaments'][number]) => tournament.name).join(', '),
    }),
    createColumn('participantName', 'Participants', {
      minWidth: 150,
      valueGetter: (value, row, column, apiRef) =>
        row.participants.map((participant: Player['participants'][number]) => participant.name).join(', '),
    }),
    createIsActiveColumn<Player>({
      updateData,
    }),
    createEditColumn<Player>({
      deleteData,
      columnName: 'Actions',
    }),
  ];

  const handleSearch = (value: string | null) => {
    changeQuery({ search: value });
  };

  return (
    <TableTemplate
      rows={playersData?.items || []}
      columns={columns}
      rowCount={playersData?.count || 0}
      loading={isFetching || isLoading}
      defaultVisibleColumns={defaultColumnsPlayers}
      createItemBtnLabel='Add new player'
      handlePaginationModelChange={updateQueryParams}
      handleSearch={handleSearch}
      handleSort={handleSort}
      formType='players'
      changeQuery={changeQuery}
      showExport
    />
  );
};

export default PlayersPage;
